import { render } from "./TVPLowlights.vue?vue&type=template&id=cc47991c"
import script from "./TVPLowlights.vue?vue&type=script&lang=js"
export * from "./TVPLowlights.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__